/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';

// Use relative imports to match project structure and avoid bundler CDN fetches
import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// If you have an image file in your repo, replace the fallback below with a relative import:
// import HealthcareImage from '../../assets/images/Industries/Healthcare_and_Medical_Practices.png';

export default function HealthcareAndMedicalPractices() {
  return (
    <>
      {/* CHALLENGES WE SOLVE */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges for Healthcare Providers</h2>
          <p className="text-center text-gray-600 mb-10">
            We help healthcare providers meet regulatory requirements, secure patient data, and offer reliable care with modern IT.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Patient Data Privacy</h3>
              <p className="text-gray-600">HIPAA-compliant systems, audit trails, and role-based access to protect sensitive records.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Telehealth & Remote Care</h3>
              <p className="text-gray-600">Secure, reliable video consultations, remote monitoring and integrations with clinical systems.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">System Reliability</h3>
              <p className="text-gray-600">Redundant backups, fast recovery, and 24/7 monitoring to keep your practice running.</p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS + OUTCOMES */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Help Healthcare Practices</h2>
            <ul className="space-y-6 text-gray-600">
              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Compliant Record Management</p>
                  <p className="text-sm">Encrypted storage, secure sharing and audit reporting to meet legal requirements.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Reliable Telehealth</p>
                  <p className="text-sm">High-quality, secure video and remote-monitoring that integrates with your workflows.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Fast Recovery & Minimal Downtime</p>
                  <p className="text-sm">Automated backups and tested disaster recovery plans so you can rely on your systems.</p>
                </div>
              </li>
            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request a Clinic Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Stronger patient privacy & compliance</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Improved appointment & communication workflows</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Reliable systems with tested backups</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Better remote care capability</strong></p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Want a healthcare IT review?</h2>
            <p className="text-gray-600 mt-2">We’ll audit your systems, recommend security improvements, and deliver a practical roadmap.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Get an Assessment</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
